import React, { useCallback } from "react";
import { getShipmentDetailsAttention, receiveTrackingNotification } from "../../../../services/shipments";
import { useFetch } from "../../../../utils/hooks";
import "./AttentionPane.scss";
import { Spin, Button } from "antd";
import { ReactSVG } from "react-svg";
import { getIcon, getPanesIcon, getUpdateIcon } from "../../../../utils/images";
import { useNavigate } from "react-router-dom";

const AttentionCard = ({ attention, refetch }) => {
  const navigate = useNavigate();

  async function handleUpload(path) {
    await receiveTrackingNotification(attention.id)
    navigate(path)
  }

  async function handleReceived() {
    await receiveTrackingNotification(attention.id)
    refetch()
  }

  return (
    <div className="AttentionCard">
      <div className="headline">
        {
          attention.kind === 'document' ?
            <div className="headline__title headline__title-danger">
              <ReactSVG src={getIcon('document-needed')} />
              <div>Documents Needed</div>
            </div>
            :
            <div className="headline__title">
              <div>
                <img src={getUpdateIcon(attention.icon)} />
              </div>
              <div>
                {attention.title}
              </div>
            </div>
        }
        <div className="date">
          {attention.date}
        </div>
      </div>

      <div className="message">
        {attention.message}
      </div>

      <div className="action">
        {
          attention.kind === 'document'
            ?
            <Button className="bold-btn" onClick={() => handleUpload(attention.url)}>Upload</Button>
            :
            <Button className="engraved-btn" onClick={handleReceived}>Received</Button>
        }
      </div>
    </div>
  )
}

const AttentionPane = ({ shipment }) => {
  const { data, loading, refetch } = useFetch(useCallback(() => getShipmentDetailsAttention(shipment.id), [shipment.id]))

  const attentions = data?.attentions || [];

  if (loading) {
    return <Spin size="large" className="spinner" />
  }

  return (
    <div className="AttentionPane pane">
      <div className="pane__header">
        <ReactSVG src={getPanesIcon('attentions')} />
        <div className="pane__title">Attentions</div>
      </div>
      <div className="pane__wrapper">
        {attentions?.map((attention, index) => <AttentionCard key={index} attention={attention} refetch={refetch} />)}
      </div>
    </div>
  )
}

export default AttentionPane;
